import React, { Component } from 'react'
import ScoreControl from './ScoreControl'


class RatingsControl extends Component {
    constructor (props){
        super(props)
        this.type = props.type;
        if(this.type === 'star') {
            this.scale = 5;
        }
        else {
            this.scale = 3;
        }
        this.state = {
            score: props.score,
            rated: props.rated
        };
    }

    componentWillReceiveProps(newProps) {
        if (!newProps) return;
        this.setState({score: newProps.score, rated: newProps.rated})
    }

    componentDidMount() {
        window.addEventListener("resize", this.updateComponentSize);
    }

    updateComponentSize = () => {
        const docWidth = this.props.getDocPageWidth();
        const availableWidth = - 28 - 12 + (window.outerWidth - docWidth) / 2;
        let container = document.getElementsByClassName('RatingsControl')[0];

        if (container && (docWidth > 0) && (availableWidth >= 240)) {
            container.setAttribute("style", "width:" + availableWidth + "px");
        }
    }

    renderMessage = () => {
        if (this.type === 'star') {
            return 'Please rate this research on scale of 1 (poor) to 5 (excellent).';
        } else if (this.type  === 'thumb') {
            return 'Did you find this research useful?';
        } else {
            return '';
        }
    }

    render(){
        let array = [];

        for(let j = this.scale; j > 0; j--) {
            array.push(j);
        }
        let thumbScore = this.state.score;

        if (this.type === 'thumb' && !this.state.rated) {
            switch (this.state.score) {
                case 2:
                    thumbScore = 1;
                    break;
                case 3:
                    thumbScore = 2;
                    break;
                case 4:
                case 5:
                    thumbScore = 3;
                    break;
                default:
                    break;
            }
        }

        return (
            <div className="RatingsControl">
                <div className="rating-info-msg">
                    { this.renderMessage() }
                </div>
                <div className="RatingsWrapper">
                    {array.map((x, i) => {
                        let rated = false;
                        if(this.type === 'star') {
                            rated = (this.state.score > x - 1);
                        } else {
                            rated = (thumbScore === x);
                        }
                        return <ScoreControl key={i} number={x} type={this.type} rated={rated} handleRatingClick={this.props.handleRatingClick}/>;
                    })}

                </div>
            </div>
        )
    }
}

export default RatingsControl